import styled from 'styled-components'
import {TreeItem} from '@mui/x-tree-view'

export const TreeItemWrapper = styled(TreeItem)`
  .MuiTreeItem-root {
    margin-left: 20px;
  }
`
